import { Grid, Link, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { Link as RouterLink } from "react-router-dom";
import EntityCard from "../../components/entityCard/EntityCard";
import dayjs, { DATE_FORMAT, ISO_DATE_FORMAT } from "../../dayjs";
import type { AdminCustomerNote } from "./customerNotesAdminApi";

type CustomerNote = Omit<AdminCustomerNote, "author"> & {
  readonly author: { readonly email: string; readonly name: string };
};

interface CustomerNoteListItemProps {
  readonly note: CustomerNote;
}

export const CustomerNoteListItem: FC<CustomerNoteListItemProps> = ({ note }) => (
  <EntityCard role="ADMIN" onClick={() => {}} onContextMenu={() => {}} childrenSpacing={2}>
    <Grid size={3}>
      <Stack>
        <Link
          underline="none"
          component={RouterLink}
          to={`/customers/${note.customer.id}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {note.customer.name}
        </Link>
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
          }}
        >
          {dayjs(note.date, ISO_DATE_FORMAT).format(DATE_FORMAT)}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
          }}
        >
          {note.author.name}
        </Typography>
        {note.type && (
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
            }}
          >
            {note.type}
          </Typography>
        )}
      </Stack>
    </Grid>
    <Grid size={9}>
      <Typography variant="body2">{note.text}</Typography>
    </Grid>
  </EntityCard>
);
